module.exports = __webpack_public_path__ + "static/media/header-medium.47a5530f.jpg";